import React from "react"
import styles from "./styles.scss"
import posed from "react-pose"

const PosedTextContainer = posed.div({
  enter: { scale: 1, delay: 1050 },
  exit: { scale: 0 },
})

class Text extends React.PureComponent {
  render() {
    const { chartRevealed, activeStep } = this.props

    const PosedText = posed.div({
      enter: {
        opacity: 1,
        y: 0,
        transition: { type: "tween", duration: 250 },
      },
      exit: { opacity: 0, y: 40 },
    })

    return (
      <PosedTextContainer
        className={styles.textContainer}
        initialPose="exit"
        pose={chartRevealed ? "enter" : "exit"}
      >
        <PosedText initialPose="exit" pose="enter">
          <h2>{activeStep.title}</h2>
          <p className={styles.text}>{activeStep.text}</p>
        </PosedText>
      </PosedTextContainer>
    )
  }
}

export default Text



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/Text/index.jsx